/**
 * Copyright (C) Firstlight Media. All rights reserved.
 * All information contained herein is and remains the property of Firstlight Media.
 * The intellectual and technical concepts contained herein are proprietary
 * to Firstlight Media. Dissemination of this information or reproduction
 * of this material is strictly forbidden unless prior written permission
 * is obtained from Firstlight Media.
 */
import { MetaTag } from './MetaTag';

export class MetadataInformation {
  metaTags: MetaTag[];

  constructor(metaTags: MetaTag[]) {
    this.metaTags = metaTags;
  }

  tagIds(): string[] {
    return this.metaTags.map((metaTag: MetaTag) => metaTag.id);
  }

  tagsById(tagId: string): MetaTag[] {
    return this.metaTags.filter((metaTag: MetaTag) => metaTag.id === tagId);
  }

  toString(): string {
    const asString: string[] = [];

    this.metaTags.forEach((metaTag: MetaTag) => {
      asString.push('{');
      asString.push(`id=${metaTag.id}`);
      asString.push(`, type=${metaTag.type}`);
      asString.push(`, attr=[${this.bytesToString(metaTag.extendedAttributes)}]`);
      asString.push('}');
    });
    asString.push('');

    return asString.join('');
  }

  /**
   * Creates a string from an array of bytes.
   * @param data
   */
  private bytesToString(data: number[]): string {
    let str = '';

    for (let i = 1; i < data.length; i++) {
      str += String.fromCharCode(data[i]);
    }

    return str;
  }
}
